import utils from '../utils'

export const loadInventory = ({ commit }) => {
  return new Promise((resolve, reject) => {
    let xhr = new XMLHttpRequest()
    xhr.open('GET', 'ws/pz_content')
    xhr.responseType = 'json'
    xhr.onload = () => {
      commit('inventory', xhr.response)
      resolve()
    }
    xhr.send()
  })
}

export const setData = ({ commit }, data) => {
  commit('setData', data)
}

export const setId = ({ commit }, id) => {
  commit('setId', id)
}

export const display = ({ commit, actions }, payload) => {
  // payload = { node, nodeType }
  commit('nodeType', payload.nodeType)
  commit('node', payload.node)
  commit('schema')
  commit('emptyValues')
  commit('context', 'display')
}

export const addNode = ({ commit }, nodeType) => {
  commit('nodeType', nodeType)
  commit('emptyValues')
  commit('schema')
  if (nodeType == 'location') {
    commit('locationDefault')
  }
  commit('context', 'add')
}

export const cloneNode = ({ commit }) => {
  commit('clone')
  commit('context', 'add')
}

export const edit = ({ commit }) => {
  commit('values')
  commit('context', 'edit')
}

export const deleteNode = ({ state, commit, getters }) => {
  let payload = {
    container: getters.nodeContainer,
    node: state.node
  }
  commit('context', null)
  commit('node', null)
  commit('nodeType', null)
  commit('deleteNode', payload)
}

export const submit = ({ commit, state, getters, dispatch }) => {
  if (state.context == 'add') {
    let newNode = createNode(state)
    let container = getters.nodeContainer
    if (container == null) {
      console.warn(`Can't add node of unknown type: "${state.nodeType}"`)
    } else {
      commit('addNode', { container, newNode })
      commit('incrementId')
    }
    dispatch('display', { node: newNode, nodeType: state.nodeType })
  } else if (state.context == 'edit') {
    commit('edit', getLabel(state))
    commit('context', 'display')
  } else {
    console.warn(`Unknown behaviour for action "submit" with context "${state.context}"`)
  }
  commit('emptyValues')
}

function createNode (state) {
  let newNode = {
    id: state.seed,
    label: getLabel(state),
    data: utils.cloneObject(state.values)
  }
  if (state.nodeType == 'station') {
    Object.assign(newNode, { location: [], channel_collection: [] })
  }
  return newNode
}

function getLabel (state) {
  return (
    state.nodeType == 'network' ? state.values['fdsn'] :
    state.nodeType == 'station' ? state.values['iris_code'] :
    state.nodeType == 'location' ? (state.values['code'] == '' ? '--' : state.values['code']) :
    state.nodeType == 'channel_collection' ? getChannelCollectionLabel(state) :
    'undefined'
  )
}

function getChannelCollectionLabel (state) {
  if (state.values != null && state.values.channel != null) {
    let network = state.data.network.find(x => x.id == state.values.network)
    let location = state.stationNode.location.find(x => x.id == state.values.location)
    let prefix = `${network.label}_${location.label}`
    if (state.values.channel.length == 1) {
      return `${prefix}${state.values.channel[0]['iris_code']}`
    } else {
      let compList = state.values.channel.map(x => x['iris_code'][2])
      let channelPrefix = state.values.channel[0]['iris_code'].substr(0, 2)
      return `${prefix}${channelPrefix}[${compList.join('')}]`
    }
  }
}
